import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Phone = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M16.51 19.995c-1.334.141-6.386-2.342-10.528-6.565C-.282 7.007-.242 4.199.141 3.23.526 2.26 2.991.28 2.991.28c.444-.363.869-.383 1.314 0l3.758 3.779a.94.94 0 0 1 0 1.353L6.184 7.29c2.142 3.777 6.567 6.645 6.567 6.645 0-.08 1.96-2.001 1.96-2.001.384-.381.93-.381 1.273 0l3.758 3.779c.344.483.344.807 0 1.353 0 .02-1.838 2.767-3.232 2.929" }) }));
});
Phone.displayName = 'Phone';
Phone.__iconComponentType = 'standard';
export default Phone;
//# sourceMappingURL=Phone.js.map